import { CarrierLogo } from '@/components/atoms/CarrierLogo/Component'
import { Typography } from '@/components/atoms/Typography/Component'
import { Breakpoint } from '@/enums'
import { themeBreakpointDown } from '@/utils'
import styled from 'styled-components'
import { Column, PageWidgetContainer, Row } from '../../components/styled'

export const InsuranceCardTextSection = styled(Column)`
  gap: 4px;
  > span {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
`

export const WelcomeBackMessageContainer = styled(Column)`
  gap: 4px;
  margin-bottom: 24px;
`

export const SectionWrapper = styled(Column)`
  width: 100%;
  padding: 24px;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.color.b30};
  background-color: ${({ theme }) => theme.color.b0};
`

export const CardWrapper = styled(Column)<{ onClick?: () => void }>`
  width: 100%;
  min-width: 0;
  height: 100%;
  gap: 48px;
  padding: 16px;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.color.b30};
  background-color: ${({ theme }) => theme.color.b0};
  justify-content: space-between;
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
`

export const CoverageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;

  ${themeBreakpointDown(Breakpoint['2xl'])} {
    grid-template-columns: repeat(1, 1fr);
  }
`

export const CardCarrierLogo = styled(CarrierLogo)`
  width: 40px;
  height: 40px;
  border: 1px solid ${({ theme }) => theme.color.b30};
  border-radius: 8px;
`

export const CoverageTopSection = styled(Column)`
  gap: 16px;
  overflow: hidden;
`

export const StatusRow = styled(Row)`
  align-items: center;
  gap: 8px;
`

export const CoverageBottomSection = styled(Row)`
  align-items: center;
  gap: 16px;
  justify-content: space-between;

  ${themeBreakpointDown(Breakpoint.xs)} {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const EmptyStateContainer = styled(Column)`
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 24px 0;
  grid-column-start: 1;
  grid-column-end: span 2;
  text-align: center;

  span {
    text-align: center;
  }
`

export const CoverageTitleSection = styled(Row)`
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
  flex-wrap: wrap;

  > * {
    flex: 1;
  }

  > span {
    hyphens: none;
  }

  > div {
    max-width: 400px;
  }
`

export const RiskInsuredColumn = styled(Column)`
  overflow: hidden;
  gap: 4px;

  svg {
    flex-shrink: 0;
  }
`

export const CategoryLabelRow = styled(Row)`
  align-items: center;
  gap: 4px;

  svg {
    flex-shrink: 0;
    margin-top: 4px;
    align-self: flex-start;
  }
`

export const CarouselSection = styled(Column)`
  background-color: ${({ theme }) => theme.color.electric500};
  border-radius: 16px;
  padding: 24px 0 0;
`

export const CarouselWrapper = styled.div`
  width: 100%;
  position: relative;
  padding: 8px 0;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.color.electric500};

  ${themeBreakpointDown(Breakpoint.xs)} {
    padding: 8px 0 8px 0;
  }
`

export const CarouselSectionHeader = styled(Column)`
  gap: 8px;
  padding: 0 24px;

  ${themeBreakpointDown(Breakpoint.xs)} {
    padding: 0 16px;
  `

export const MobileCoverageButtonContainer = styled(Row)`
  padding: 0 8px 16px 8px;
`

export const ContentCardButtonWrapper = styled(Column)`
  position: relative;
  justify-content: space-between;
  border-radius: 16px;
  overflow: hidden;
  width: 100%;
  height: 180px;
  padding: 16px;
  cursor: pointer;
  background-color: ${({ theme }) => theme.color.b0};
  text-align: left;
`

export const ContentCardWrapper = styled(Column)`
  width: 100%;
  height: 100%;
  justify-content: space-between;
`

export const ViewAllCardWrapper = styled(ContentCardButtonWrapper)`
  background: transparent;
  justify-content: center;
  align-items: center;

  &:before {
    content: '';
    position: absolute;
    background: ${({ theme }) => theme.color.b100};
    opacity: 0.4;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

export const ContentCardHeader = styled(Column)`
  width: 100%;
  gap: 4px;
`

export const RecommendationCardHeader = styled(Column)`
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
  overflow: hidden;
`

export const RecommendationCardHeaderText = styled(Column)`
  width: 100%;
  min-width: 0;
  gap: 4px;
`

export const RecommendationCardCarrierLogo = styled(CarrierLogo)`
  width: 32px;
  height: 32px;
  border: 1px solid ${({ theme }) => theme.color.b30};
  background-color: ${({ theme }) => theme.color.b0};
  border-radius: 8px;
`

export const RecommendationCardLogosStack = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;

  > *:not(:first-child) {
    margin-left: -16px;
  }
`

export const RecommendationCardFooter = styled(Row)`
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`

export const NewTag = styled(Row)`
  width: fit-content;
  background-color: ${({ theme }) => theme.color.danger1};
  border-radius: 200px;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;

  > span {
    font-size: 9px;
  }
`

export const MiddleSectionColumn = styled(Column)`
  min-width: 0;
  flex: 1;
  max-width: 100%;
  gap: 24px;
`

export const StyledPageWidgetContainer = styled(PageWidgetContainer)`
  padding-right: 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const PaymentPeriodText = styled(Typography)`
  white-space: nowrap;
`

export const HeaderTextColumn = styled(Column)`
  gap: 2px;
  min-width: 0;
`

export const CoverageCardHeaderRow = styled(Row)`
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
  overflow: hidden;
`

export const TextAndLogoSection = styled(Row)`
  align-items: center;
  gap: 16px;
  width: 100%;
`
